// client/src/pages/ShopPOS/components/ProductCard.tsx
import { Card, CardContent } from "@/components/ui/card";

interface ProductCardProps {
  item: any;
  product: any;
  onAddToCart: (id: string) => void;
  getCurrencySymbol: () => string;
}

export function ProductCard({
  item,
  product,
  onAddToCart,
  getCurrencySymbol,
}: ProductCardProps) {
  return (
    <Card
      className="cursor-pointer hover:shadow-lg transition-all hover:border-primary active:scale-95"
      onClick={() => onAddToCart(item.id)}
      data-testid={`product-card-${item.id}`}
    >
      <CardContent className="p-4 flex flex-col h-full justify-between">
        <div>
          <div className="text-xs font-bold text-muted-foreground mb-1 uppercase">
            {product.category}
          </div>
          <div className="font-bold leading-tight mb-2">{product.name}</div>
        </div>
        <div className="flex flex-col md:flex-row md:justify-between md:items-end mt-2 gap-2 md:gap-0">
          <div className="text-xl font-bold text-primary">
            {getCurrencySymbol()}
            {item.price}
          </div>
          <div className="text-xs text-muted-foreground bg-muted px-2 py-1 rounded self-start md:self-auto">
            Stock: {item.stock}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
